<ng-container *transloco="let t; read: 'ime.components.help'">
  <ul class="ps-1 text-break">
    <li *ngFor="let topic of topics | orderBy: 'Value'">
      <a [class.fw-bold]="topic.Id === selectedId" [routerLink]="['/help/' + topic.Id]">
        {{topic.Value}}
      </a>
    </li>
  </ul>
  <div class="input-group">
    <input type="text" class="form-control" placeholder="{{t('New topic')}}" [(ngModel)]="newTopic">
    <button type="button" class="btn btn-sm btn-outline-primary" (click)="addTopic()">
      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
      {{t('Add')}}
    </button>
  </div>
</ng-container>
